import { Person } from '@/interfaces/person/index';
import { DetailLicenseById, Equipments, TableType2 } from '@/interfaces/search/search.interface';
import { SearchService } from '@/services/search/search.service';
import { StoreState } from '@/store';
import { modalShow } from '@/store/modal/actions';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { ofuscate } from '@/utils/obfuscation';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-search-driver-licenses-delete-equipment',
  templateUrl: './delete-equipment.component.html',
  styleUrls: ['./delete-equipment.component.css'],
})
export class DeleteEquipmentComponent implements OnInit, OnChanges {
  @Input() showDetailLicense: boolean = false;
  @Input() detailLicense?: DetailLicenseById;
  @Input() licenseSelectedId: number = 0;
  @Output() handleBack: EventEmitter<void> = new EventEmitter();
  @Input() personData!: Person;
  @Output() refreshLicenseCards = new EventEmitter();

  nameAsset?: string = '';
  numberLicense?: string = '';
  restrictionDriver?: string = ''

  longNameAsseteOfLicense?: string = '';

  // activeLink:boolean = false;
  showButtonDelete: boolean = true;
  deletingEquipments: boolean[] = [];
  deletingZone: boolean[] = [];
  deletingTypeLicense: boolean[] = [];
  typeSelect: string = ''

  constructor(
    private store: Store<StoreState>,
    private router: Router,
    private route: ActivatedRoute,
    private searchService: SearchService,
    private cdr: ChangeDetectorRef,
  ) {

  }

  ngOnInit(): void {

  }

  ngOnChanges() {
    if (this.licenseSelectedId) {
      this.nameAsset = this.detailLicense?.name;
      this.numberLicense = this.detailLicense?.licenseNumber;
      this.restrictionDriver = this.detailLicense?.drivingRestriction;
    }
  }

  get shouldShowWarningMessage(): boolean {
    if (this.detailLicense?.equipments.some((equipment) => equipment.licenseTypes.length === 1 || equipment.conductionZones.length === 1)) {
      return true;
    }
    return false;
  }

  listToSelect(idEquipment: number, typeSelect: string) {
    this.detailLicense?.equipments.map(({ equipmentId }, index) => {
      if (idEquipment === equipmentId) {
        if (typeSelect === 'zone') this.deletingZone[index] = !this.deletingZone[index];
        if (typeSelect === 'typeLicense') this.deletingTypeLicense[index] = !this.deletingTypeLicense[index];
      }
    });
  }

  onDeleteEquiment(idEquipment: number) {
    const selectedEquiment = this.detailLicense?.equipments.find(({ equipmentId }) => equipmentId === idEquipment);
    if (selectedEquiment) {
      this.store.dispatch(modalShow({
        title: '¿Estás seguro de eliminar esta información?',
        text: 'La Información será eliminada de tus registros si continúa.',
        text2: 'Presiona Volver para revisar la información.',
        acceptButtonText: 'Eliminar Información',

        actionOnAccept: () => {
          this.store.dispatch(loaderAnimationShow());
          this.searchService.onDeleteEquipment(this.licenseSelectedId, idEquipment)
            .subscribe({
              next: (res) => {
                this.refreshLicenseCards.emit();
                const index = this.detailLicense?.equipments.findIndex((e) => e.equipmentId === idEquipment);
                this.detailLicense?.equipments.splice(<number>index, 1);
                this.store.dispatch(loaderAnimationHide());
              },
              error: () => {
                this.store.dispatch(loaderAnimationHide());
                this.store.dispatch(modalShow({
                  title: 'Error',
                  text: 'Hubo un error, No se ha podido eliminar la  información seleccionada',
                  text2: 'Presiona Regresar para  Volver a  intentarlo.',
                  acceptButtonText: 'Regresar',
                  noShowButtonBack: true,
                  actionOnAccept: () => {
                  },
                }));

              },
              complete: () => {
                // segundo dispatch
                this.store.dispatch(loaderAnimationHide());
              },

            });

        },

      }));
    }
  }

  onDeleteZone(idEquipmentSelected: number, idZone: number) {
    if (idZone === undefined) return;
    const selectedEquiment = this.detailLicense?.equipments.find(({ equipmentId }) => equipmentId === idEquipmentSelected);
    const selectedZone = selectedEquiment?.conductionZones.find(({ id }) => id === idZone);
    if (selectedEquiment && selectedZone) {
      this.store.dispatch(modalShow({
        title: '¿Estás seguro de eliminar esta información?',
        text: 'La Información será eliminada de tus registros si continúa.',
        text2: 'Presiona Volver para revisar la información.',
        acceptButtonText: 'Eliminar Información',

        actionOnAccept: () => {
          this.store.dispatch(loaderAnimationShow());
          this.searchService.onDeleteZone(this.licenseSelectedId, idEquipmentSelected, selectedZone.id)
            .subscribe({
              next: () => {
                if (this.detailLicense) {
                  this.detailLicense.equipments.reduce<DetailLicenseById['equipments']>((equipments, equipment) => {
                    const newEquipment = equipment;
                    if (equipment.equipmentId === idEquipmentSelected) {
                      newEquipment.conductionZones = equipment.conductionZones.reduce<Equipments['conductionZones']>((conductionZones, conductionZone) => {
                        if (!(conductionZone.id === idZone)) {
                          conductionZones.push(conductionZone);
                        }
                        return conductionZones;
                      }, []);
                    }
                    equipments.push(newEquipment);
                    return equipments;
                  }, []);
                }
                this.refreshLicenseCards.emit();
                this.listToSelect(selectedEquiment.equipmentId, 'zone');
                this.store.dispatch(loaderAnimationHide());
              },
              error: () => {
                this.listToSelect(selectedEquiment.equipmentId, 'zone');
                this.store.dispatch(loaderAnimationHide());
              },
            });
        },
      }));
    }
  }

  onDeleteTypeLicense(idEquipmentSelected: number, typeId: number) {
    if (typeId === undefined) return;
    const selectedEquiment = this.detailLicense?.equipments.find(({ equipmentId }) => equipmentId === idEquipmentSelected);
    const selectedType = selectedEquiment?.licenseTypes.find(({ id }) => id === typeId);
    if (selectedEquiment?.equipmentId && selectedType?.id) {
      this.store.dispatch(modalShow({
        title: '¿Estás seguro de eliminar esta información?',
        text: 'La Información será eliminada de tus registros si continúa.',
        text2: 'Presiona Volver para revisar la información.',
        acceptButtonText: 'Eliminar Información',
        actionOnAccept: () => {
          this.store.dispatch(loaderAnimationShow());
          this.searchService.onDeleteTypeLicense(this.licenseSelectedId, selectedEquiment.equipmentId, selectedType.id)
            .subscribe({
              next: (res) => {
                if (this.detailLicense) {
                  this.detailLicense.equipments = this.detailLicense?.equipments.reduce<DetailLicenseById['equipments']>((equipments, equipment) => {
                    const newEquipment = equipment;
                    if (equipment.equipmentId === idEquipmentSelected) {
                      newEquipment.licenseTypes = equipment.licenseTypes.reduce<Equipments['licenseTypes']>((licenseTypes, licenseType) => {
                        if (!(licenseType.id === typeId)) {
                          licenseTypes.push(licenseType);
                        }
                        return licenseTypes;
                      }, []);
                    }
                    equipments.push(newEquipment);
                    return equipments;
                  }, []);
                }

                this.refreshLicenseCards.emit();
                this.listToSelect(selectedEquiment.equipmentId, 'typeLicense');
                this.store.dispatch(loaderAnimationHide());
              },
              error: () => {
                this.store.dispatch(loaderAnimationHide());
              },
              complete: () => {
                this.store.dispatch(loaderAnimationHide());
              },
            });
        },
      }));
    }
  }

  // modal  confirmacion to do  tipo de la licencia agregarla al pop up
  onDeleteLicense(idLicenseSelected?: number) {
    if (idLicenseSelected) {
      this.licenseSelectedId = idLicenseSelected;
      this.longNameAsseteOfLicense = this.detailLicense?.name;
      this.store.dispatch(modalShow({
        title: '¿Estás seguro que quieres eliminar esta licencia?',
        text: 'La licencia será eliminada automáticamente si continúa en Eliminar Licencia.',
        text2: 'Presiona Volver para regresar a la pantalla anterior.',
        acceptButtonText: 'Eliminar Licencia',
        actionOnAccept: () => {
          const currentOfuscatedData = this.router.url.split('/').reverse()[1];
          this.store.dispatch(loaderAnimationShow());
          this.searchService.onDeleteLicenseById(idLicenseSelected)
            .subscribe({
              next: (res) => {
                const ofuscatedData = ofuscate({
                  title: 'Eliminar Licencia',
                  subtitle: `La licencia ${this.longNameAsseteOfLicense} ha sido eliminada exitosamente.`,
                  messageBold: `N° registro: ${this.detailLicense?.licenseNumber || ''}`,
                  message: `Una copia de la eliminación fue enviada al
              correo electrónico ${this.personData.email}`,
                  actionButtonPath: `/search/driver/result/${currentOfuscatedData}/licenses`,
                  actionButtonText: 'Ir al perfil de conductor',
                });
                this.store.dispatch(loaderAnimationHide());
                this.router.navigateByUrl(`/search/action/result/${ofuscatedData}`);

              },
              error: () => {
                this.store.dispatch(loaderAnimationHide());

                this.store.select('pageError').subscribe({
                  next: (pageConfig) => {
                    const [website, ...url] = window.location.href.split('//')[1].split('/');
                    if (pageConfig.errorType !== 'Mulesoft') {
                      const ofuscatedData = ofuscate({
                        variant: 'failure',
                        title: 'Eliminar Licencia',
                        subtitle: 'Hubo un problema y no hemos podido eliminar  La licencia. Por favor intenta de nuevo.',
                        actionButtonPath: `/search/driver/result/${currentOfuscatedData}/licenses`,
                        actionButtonText: 'Ir al perfil de conductor',
                      });
                      this.router.navigateByUrl(`/search/action/result/${ofuscatedData}`);

                    }
                  },
                });

              },
              complete: () => {
                this.store.dispatch(loaderAnimationHide());
              },
            });
        },
      }));
    }
  }

}
